module.exports = __webpack_public_path__ + "img/comodas-e-penteadeiras.a85dc4be.webp";